import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./main-point-slide.css";

import type { SlideViewMode } from "../slide/slide";

@customElement("bp-main-point-slide")
export class MainPointSlide extends LitElement {
  static styles = styles;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <div class="main-point-slide ${this.viewMode}">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-main-point-slide": MainPointSlide;
  }
}
